import { Editor } from '@tiptap/core'
import StarterKit from '@tiptap/starter-kit'
import { Underline } from '@tiptap/extension-underline'
import Subscript from '@tiptap/extension-subscript'
import Superscript from '@tiptap/extension-superscript'
import { Video } from './extensions/video'
import { Audio } from './extensions/audio'
import { TTImage } from './extensions/image'
import UniqueID from '@tiptap-pro/extension-unique-id'

export const convertFromJSON = (json) => {
  try {
    if (json) {
      const editor = new Editor({
        // @ts-ignore
        extensions: [
          StarterKit.configure({ heading: { levels: [1, 2, 3] } }),
          Video,
          TTImage,
          Underline,
          Subscript,
          Audio,
          Superscript,
          UniqueID.configure({
            types: [
              'paragraph',
              'audio',
              'listItem',
              'bulletList',
              'orderedList',
              'heading',
              'image',
              'video',
            ],
            attributeName: 'node_id',
            filterTransaction: (transaction) => {
              // transaction.steps.map((step) => console.log(step.toJSON()))
              // true splits a new uid
              return true
            },
          }),
        ],
        content: json,
      })
      return editor.getHTML()
    }
    return ''
  } catch {
    return ''
  }
}
